let exampleList = {
    "tickers":['BTCUSDT','XRPUSDT','DOGEUSDT','TUSDT','LTCUSDT']
}
function getSymbol(){

}

export {
    getSymbol,
    exampleList
}